/** R2 SQLite path — served by allworld from allworld-sites/26-fatigue-bid/db/ */
export const SQLITE_R2_PATH = '/db/26-fatigue-bid.sqlite'
export const PROJECT_SLUG = '26-fatigue-bid'
export const DEPLOYMENT_HOST = 'https://26-fatigue-bid.softwarelink.net/'
